import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ActionReasonsResponse {
  action: string;
  reasons: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ActionReasonsService {

    constructor(private http: HttpClient) {}
    /**
     * Fetches ALL actions with their reasons for a workspace
     *
     * @param workspaceId - The workspace identifier
     * @returns Observable of all actions with their reasons
     */
    getAllActionReasons(workspaceId: string): Observable<ActionReasonsResponse[]> {
        const url = `${environment.backendUrl}/invoicestore/app/api/action-reasons`;
        const params = new HttpParams().set('workspaceId', workspaceId);

        return this.http.get<ActionReasonsResponse[]>(url, { params });
    }
}
